/**
 * Display subject name: only the part after "/" if present, otherwise the full value.
 * Same logic as in Products, NewProducts, NewWave.
 */
export function formatSubjectName(subjectName: string | null | undefined): string {
  if (subjectName == null || subjectName === '') return '—';
  const slashIndex = subjectName.indexOf('/');
  return slashIndex !== -1 ? subjectName.substring(slashIndex + 1) : subjectName;
}
